import React, { useState, useEffect } from 'react';
import { auth } from '../firebaseConfig'; // Varmista, että polut ovat oikein
import styles from '../Styles/Consent.module.css';
import { useNavigate } from 'react-router-dom';
import UsersApi from "../Api/UsersApi";
import { useUsers } from '../Commoncontext/UsersContext';

function Consent() {
  const { user, setUser } = useUsers();
  const [consentGiven, setConsentGiven] = useState(false);
  const [consentDate, setConsentDate] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    if (user && user.suostumus) {
      setConsentGiven(true);
      let formattedDate = "Ei saatavilla";
      if (user.suostumusAika) {
        formattedDate = new Date(user.suostumusAika).toLocaleDateString("fi-FI");
      }
      setConsentDate(formattedDate);
   }
  }, [user]);

  const handleConsent = async () => {
    if (auth.currentUser) {
      try {
        await UsersApi.updateUserConsent(auth.currentUser.uid);
        const localTimestamp = new Date();
        setConsentGiven(true);
        setConsentDate(localTimestamp.toLocaleDateString("fi-FI"));
        setUser(prevUser => ({
            ...prevUser,
            suostumus: true,
            suostumusAika: localTimestamp
          }));
        alert('Suostumus tietosuojaselosteeseen on tallennettu.');
        navigate('/frontpage');
      } catch (error) {
        console.error('Virhe tallennettaessa suostumusta:', error);
        alert('Virhe tallennettaessa suostumusta.');
      }
    } else {
      alert('Ei kirjautunutta käyttäjää.');
    }
  };

  return ( 
    <main className={styles.content}>
    <div>
    <h1>Tietosuojaseloste: As Oy Tuusulan Metsänkuninkaan <br></br>talonyhtiöportaalin käyttäjätietojen käsittely</h1>    
    <div>
        <h2>1. Rekisterinpitäjä</h2>
        <p>Nimi: Asunto Oy Tuusulan Metsänkuningas</p>
        <p>Yhteystiedot: Isokarhunaukio 1, 04300 Tuusula</p>
        <p>Puhelin: 040 502 3843</p>
        <p>Sähköposti: jani.rantala@hotmail.com</p>

        <h2>2. Yhteyshenkilö rekisteriä koskevissa asioissa</h2>
        <p>Nimi: Jani Rantala</p>
        <p>Sähköposti: jani.rantala@hotmail.com</p>

        <h2>3. Rekisterin nimi</h2>
        <p>As Oy Tuusulan Metsänkuninkaan talonyhtiöportaalin käyttäjärekisteri</p>
        
        <h2>4. Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</h2>
        <p>Henkilötietojen käsittelyn oikeusperusteena on rekisteröidyn suostumus, joka saadaan kun käyttäjä <br></br> rekisteröityy talonyhtiöportaaliin. Henkilötietoja käsitellään seuraaviin tarkoituksiin:</p>
          <ul>
            <li>Yhteisten tilojen, kuten sauna- ja etätyötilojen, varauksien hallinta.</li>
            <li>Käyttäjien tukipalveluiden tarjoaminen.</li>
            <li>Mahdollisten tulevien palveluiden ja tapahtumien tiedottaminen.</li>
          </ul>
        

        <h2>5. Rekisterin tietosisältö</h2>
        <p>Rekisteri sisältää seuraavat tiedot käyttäjistä:</p>
        <ul>
          <li>Etunimi ja sukunimi</li>
          <li>Sähköpostiosoite</li>
          <li>Puhelinnumero</li>
          <li>Osoite</li>
        </ul>

        <h2>6. Säännönmukaiset tietolähteet</h2>
        <p>Henkilötiedot saadaan suoraan rekisteröidyiltä itseltään rekisteröintiprosessin yhteydessä ja heidän <br></br>käyttäessään portaalin palveluita.</p>

        <h2>7. Tietojen säännönmukaiset luovutukset</h2>
        <p>Tietoja ei luovuteta säännönmukaisesti kolmansille osapuolille, paitsi lain sallimissa ja <br></br>velvoittamissa rajoissa.</p>

        <h2>8. Tietojen siirto EU:n tai ETA:n ulkopuolelle</h2>
        <p>Henkilötietoja ei siirretä EU:n tai ETA:n ulkopuolelle, ellei se ole tarpeellista palvelun teknisen <br></br>toteutuksen vuoksi.</p>

        <h2>9. Rekisterin suojauksen periaatteet</h2>
        <p>Henkilötiedot säilytetään luottamuksellisina. Tietokanta, jossa henkilötiedot sijaitsevat, on suojattu <br></br>salasanalla ja pääsy tietoihin on rajattu vain niille henkilöstön jäsenille, jotka tarvitsevat tietoja <br></br>työtehtäviensä hoitamiseen.</p>

        <h2>10. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</h2>
        <p>Jokaisella rekisteröidyllä on oikeus tarkastaa häntä koskevat rekisteritiedot ja vaatia mahdollisen <br></br>virheellisen tiedon korjaamista. Pyynnöt tulee lähettää kirjallisesti rekisterinpitäjälle.</p>

        <h2>11. Muut henkilötietojen käsittelyyn liittyvät oikeudet</h2>
        <p>Rekisteröidyllä on oikeus pyytää henkilötietojen poistamista rekisteristä ("oikeus tulla unohdetuksi"), <br></br>jos käsittely ei ole tarpeellista. Rekisteröidyllä on myös oikeus kieltää henkilötietojensa käsittely <br></br>suoramarkkinointitarkoituksiin.</p>
        
        {consentGiven ? (
          <button className={styles.stateButton} disabled>Tietosuojaseloste hyväksytty: {consentDate}</button>
        ) : (
          <button className={styles.stateButton} onClick={handleConsent}>Hyväksy tietosuojaseloste</button>
        )}
      </div>
    </div>
    </main>
  );
}

export default Consent;